import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import { inspect } from 'util';
import {
  ThomasCampaign,
  ThomasCampaignProduct,
  AdServer,
  CampaignModuleProps,
  ProductFulfillment
} from 'models/interfaces';
import { campaignHasFulfillment } from 'models/constants/index';
import { Formik, Form } from 'formik';
import { StackedText, StackedSelect, StackedDatePicker } from '@tpco/blueprint-react';
import './ThomasCampaignEdit.scss';
import { ApolloConsumer } from 'react-apollo';
import {
  validateStartDate,
  validateEndDate,
  validateCampaignModule
} from './ThomasCampaignValidation';
import { getCampaignModuleConfiguration } from './CampaignModuleConfiguation';
import { ApolloClient } from 'apollo-client';
import { toast } from 'react-toastify';
import { SAVE_CAMPAIGN_MUTATION } from 'containers/ThomasCampaignContainer';
import { printDate } from 'util/dateUtils';
import { canBeEdited } from 'util/p3Validation';
import { buildURL } from 'util/nameHelper';
interface IThomasCampaignEditProps {
  isNewCampaign: Boolean;
  tgramsId: string;
  companyName: string;
  campaign: ThomasCampaign;
  productFulfillment?: ProductFulfillment;
  adServerId?: number;
  products: ThomasCampaignProduct[];
  adServers: AdServer[];
  client: ApolloClient<any>;
}

type ThomasCampaignEditProps = RouteComponentProps<{}> & IThomasCampaignEditProps;

interface ThomasCampaignEditState {
  name: string;
  productId: number;
  campaignId: string;
  startDate?: any;
  endDate?: any;
  adServerId: number;
  childCampaign: any;
  childProductName: string;
  getCampaignModule(apolloClient: any): Promise<any>;
  renderCampaignModule(props: CampaignModuleProps): JSX.Element | null;
  renderCampaignPublish(
    thomasCampaignStatus: number,
    productFulfillment: any,
    publishCampaign: () => any
  ): JSX.Element | null;
  mutateCampaignModule(apolloClient: any, campaign: any): Promise<any>;
  publishCampaignModule(apolloClient: any, publishInput: any): Promise<any>;
  tgramsId: string;
  isPublishing: boolean;
}

class ThomasCampaignEdit extends React.Component<ThomasCampaignEditProps, ThomasCampaignEditState> {
  constructor(props: ThomasCampaignEditProps) {
    super(props);

    const childProductName = '[product]';

    let name = '';
    let productId = 0;

    // set default if they exist in campaign
    if (this.props.campaign) {
      name = this.props.campaign.name || '';
      productId = this.props.campaign.product_id ? this.props.campaign.product_id : 0;
    }

    const defaultDates = this.getDefaultDates();

    const startDate = printDate(this.props.campaign.start_date)
      ? new Date(this.props.campaign.start_date)
      : defaultDates.startDate;

    const endDate = printDate(this.props.campaign.end_date)
      ? new Date(this.props.campaign.end_date)
      : defaultDates.endDate;

    // get the child campaign configuration for this product id
    const childCampaignConfig = getCampaignModuleConfiguration(productId);

    this.state = {
      name,
      campaignId: this.props.campaign.campaign_id,
      startDate,
      endDate,
      productId,
      adServerId: this.props.adServerId || 1,
      childProductName,
      childCampaign: {},
      getCampaignModule: childCampaignConfig.getCampaign,
      renderCampaignModule: childCampaignConfig.renderCampaignEdit,
      renderCampaignPublish: childCampaignConfig.renderCampaignPublish,
      mutateCampaignModule: childCampaignConfig.saveCampaign,
      publishCampaignModule: childCampaignConfig.publishCampaign,
      tgramsId: this.props.tgramsId,
      isPublishing: false
    };
  }

  buildCampaignPostModel = (values: any) => {
    const { tgramsId } = this.props;
    const { productId } = this.state;
    const status_id = this.props.campaign.status_id || CONSTANTS.CAMPAIGN_STATUS.NEW;
    const productFulfillment = this.props.productFulfillment;
    const c = this.props.campaign;
    // create thomasCampaignPostModel thomas campaign
    console.log(`display dates`, values.startDate);
    console.log(`display dates`, values.endDate);

    const campaign = {
      campaign_id: values.campaignId,
      tgrams_id: tgramsId,
      product_id: productId,
      name: values.name,
      start_date: productFulfillment ? c.start_date : values.startDate,
      end_date: productFulfillment ? c.end_date : values.endDate,
      status_id
    } as ThomasCampaign;

    return campaign;
  };

  publishCampaign = (values: any, client: ApolloClient<any>) => {
    return async () => {
      console.log(`ThomasCampaign publishCampaign`);

      this.setState({ isPublishing: true });

      try {
        // save ThomasCampaign and CampaignModule first
        await this.tryBeginSave(values, client);
      } catch (error) {
        console.log('error after save campaign: ', inspect(error, false, 10));
        const saveMessage = 'Failed to save campaign';
        console.log(saveMessage);
        console.error(error);
        toast.error(saveMessage);
        this.setState({ isPublishing: false });
        return false;
      }

      try {
        // get campaignModule
        console.log('Getting campaignModule from cache.');
        const campaignModule = await this.state.getCampaignModule(client);

        console.log('campaignModule: ', campaignModule);
        // then begin publishing
        if (campaignModule) {
          await this.state.publishCampaignModule(client, campaignModule);
        }
      } catch (error) {
        const saveMessage = 'Failed to publish campaign';
        console.log(saveMessage);
        console.error(error);
        toast.error(saveMessage);
        this.setState({ isPublishing: false });
        return false;
      }

      // show success toaster
      toast.success('Successfully queued campaign publish!');
      toast.info('Navigating to advertiser page...', { autoClose: 2000 });
      setTimeout(() => {
        this.props.history.push(`/advertisers/${this.props.campaign.tgrams_id}`);
      }, 2000);
    };
  };

  tryBeginSave = async (values: any, client: ApolloClient<any>) => {
    console.log('Saving...');
    const campaign = this.buildCampaignPostModel(values);
    try {
      const thomasCampaignSaveResponse = await client.mutate({
        mutation: SAVE_CAMPAIGN_MUTATION,
        variables: { campaign }
      });

      await this.state.mutateCampaignModule(client, this.state.childCampaign);

      // show success toaster
      toast.success('Campaign successfully saved!');
      toast.info('Navigating to advertiser page...', { autoClose: 2000 });
      setTimeout(() => {
        this.props.history.push(`/advertisers/${this.props.campaign.tgrams_id}`);
      }, 2000);
      // navigate to campaign edit page so we don't save another new campaign
      if (this.props.isNewCampaign) {
        this.navigateToEditCampaign();
      }
    } catch (error) {
      const saveMessage = 'Failed to save campaign';
      console.log(saveMessage);
      console.error(error);
      toast.error(saveMessage);

      return false;
    }
  };

  navigateToEditCampaign = () => {
    const { tgramsId } = this.props;
    const { campaignId } = this.state;
    toast.info('Navigating to edit page...', { autoClose: 2000 });
    setTimeout(() => {
      this.props.history.push(`/advertisers/${tgramsId}/campaigns/${campaignId}/edit`);
    }, 2000);
  };

  getProductAbbr = (productId?: number) => {
    switch (productId) {
      case 1:
        return 'PVS';
      case 2:
        return 'Points';
      default:
        return '[product]';
    }
  };

  onProductIdChange = ({ value }: any) => {
    let childProductName = '[ENTER NAME]';

    console.log('onProductIdChange: ', value);

    // get child campaign configuration
    const childCampaignConfig = getCampaignModuleConfiguration(parseInt(value, 10));

    console.log(`child campaign config`, childCampaignConfig);

    this.setState(
      {
        productId: parseInt(value, 10),
        childProductName,
        getCampaignModule: childCampaignConfig.getCampaign,
        renderCampaignModule: childCampaignConfig.renderCampaignEdit,
        renderCampaignPublish: childCampaignConfig.renderCampaignPublish,
        mutateCampaignModule: childCampaignConfig.saveCampaign,
        publishCampaignModule: childCampaignConfig.publishCampaign
      },
      () => this.setName()
    );
  };

  onNameChange = ({ value }: any) => {
    if (this.state.productId === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS) {
      this.setState({ name: value });
    }
  };

  setName = () => {
    // set name
    if (this.state.productId === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS) {
      const productAbbr = this.getProductAbbr(this.state.productId);
      const companyName = this.props.companyName;
      const childProductName = this.state.childProductName || '[page]';
      let name = `${productAbbr} - ${childProductName} - ${companyName}`;
      // TODO: get inventory count for this tgrams, vertical
      this.setState({
        name
      });
    }
  };

  getDefaultDates = () => {
    const now = new Date();
    const defaultStartDate =
      now.getMonth() == 11
        ? new Date(now.getFullYear() + 1, 0, 1)
        : new Date(now.getFullYear(), now.getMonth() + 1, 1);
    const defaultEndDate =
      defaultStartDate.getMonth() == 11
        ? new Date(defaultStartDate.getFullYear() + 1, 0, 1)
        : new Date(defaultStartDate.getFullYear(), defaultStartDate.getMonth() + 1, 1);

    return {
      startDate: defaultStartDate,
      endDate: defaultEndDate
    };
  };

  onModuleProductNameChange = (name: string) => {
    this.setState(
      {
        childProductName: name
      },
      this.setName
    );
  };

  onCampaignChange = (field: any) => {
    const updateValues = {
      [field.name]: field.value
    };

    if (field.name === 'startDate' || field.name === 'endDate') {
      let date = field.value ? new Date(field.value) : '';
      updateValues[field.name] = date;
    }

    this.setState({ ...((updateValues as unknown) as ThomasCampaignEditState) });
  };

  onFormValidate = async (
    values: any,
    apolloClient: ApolloClient<any>,
    getCampaignModule: (client: ApolloClient<any>) => Promise<any>
  ) => {
    console.log('Calling onFormValidate.');
    const campaignModule = await getCampaignModule(apolloClient);

    console.log('campaignModule: ', campaignModule);

    let moduleIsValid = validateCampaignModule(values.productId || 0, campaignModule);

    if (!moduleIsValid) {
      console.log('Campaign Module is not valid.');
      throw { campaignModule: 'Child Campaign is not valid' };
    }

    return null;
  };

  nameValidation = (value: string) => {
    if (!value) {
      return 'Required';
    }
    if (value.match(/\[ENTER NAME\]/g)) {
      return 'Enter a Name';
    }
  };

  campaignHasFulfillment = () => {
    const { productFulfillment } = this.props;

    return campaignHasFulfillment(productFulfillment);
  };

  areDatesEditable = () => {
    if (this.campaignHasFulfillment()) {
      return false;
    }

    return true;
  };

  isProductEditable = () => {
    if (this.campaignHasFulfillment()) {
      return false;
    }

    return true;
  };

  isCampaignEditable = () => {
    const { campaign, productFulfillment } = this.props;

    if (campaign.product_id === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS) {
      return canBeEdited(
        campaign.status_id,
        campaign.start_date,
        productFulfillment ? productFulfillment.opportunity_id : '',
        productFulfillment ? productFulfillment.order_source : ''
      );
    } else {
      return !CONSTANTS.NO_MORE_CHANGES_CAMPAIGN.includes(campaign.status_id);
    }

    return false;
  };

  isCampaignNameEditable = () => {
    const { campaign, productFulfillment } = this.props;

    if (campaign.product_id == CONSTANTS.CAMPAIGN_PRODUCT_TYPE.POINTS) {
      return canBeEdited(
        campaign.status_id,
        campaign.start_date,
        productFulfillment ? productFulfillment.opportunity_id : ''
      );
    } else {
      return true;
    }

    return false;
  };

  canSave = (isSaving: boolean) => {
    const { isPublishing } = this.state;
    const { productFulfillment, campaign } = this.props;

    if (isSaving) {
      return false;
    }

    if (isPublishing) {
      return false;
    }
    if (campaign.product_id === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS) {
      console.log('pvs campaing can save true');
      return true;
    }

    if (campaignHasFulfillment(productFulfillment)) {
      if (
        !canBeEdited(
          campaign.status_id,
          campaign.start_date,
          productFulfillment ? productFulfillment.opportunity_id : '',
          productFulfillment && productFulfillment.order_source
        )
      ) {
        console.log(`enter cannot be edited`, campaign);
        return false;
      }
    }

    return true;
  };

  render() {
    const { products } = this.props;

    let productSelectOptions: any = [];

    // make products select list
    if (products) {
      productSelectOptions = products.map((x: ThomasCampaignProduct) => {
        return {
          value: x.product_id,
          name: x.name
        };
      });
    }

    const {
      productId,
      name,
      campaignId,
      startDate,
      endDate,
      getCampaignModule,
      renderCampaignModule,
      renderCampaignPublish,
      tgramsId
    } = this.state;

    const initialValues = {
      productId: productId || 0,
      name,
      campaignId,
      startDate: startDate,
      endDate: endDate,
      campaignModule: 'My Module'
    };

    const { companyName, campaign, productFulfillment } = this.props;

    const childComponentRenderProps: CampaignModuleProps = {
      tgramsId,
      companyName,
      startDate,
      endDate,
      productFulfillment,
      onModuleProductNameChange: this.onModuleProductNameChange,
      campaign
    };
    return (
      <div className="edit-campaign__container">
        <ApolloConsumer>
          {client => (
            <React.Fragment>
              <Formik
                initialValues={initialValues}
                validate={async values => this.onFormValidate(values, client, getCampaignModule)}
                onSubmit={values => this.tryBeginSave(values, client)}
                enableReinitialize={true}
              >
                {({ isValid, isSubmitting, values, errors, submitForm }) => (
                  <React.Fragment>
                    <Form className="card edit-campaign__container">
                      <StackedSelect
                        htmlId="edit-campaign-product"
                        fieldName="productId"
                        labelText="Product"
                        className="saturn-form-group saturn-col saturn-flex-column"
                        disabled={!this.isProductEditable()}
                        onChange={this.onProductIdChange}
                        options={productSelectOptions}
                      />

                      <StackedText
                        htmlId="edit-campaign-name"
                        fieldName="name"
                        labelText="Campaign Name"
                        className="saturn-form-group saturn-col saturn-flex-column"
                        onChange={this.onNameChange}
                        disabled={!this.isCampaignNameEditable()}
                        validate={this.nameValidation}
                      />
                      <StackedText
                        htmlId="edit-campaign-id"
                        fieldName="campaignId"
                        className="saturn-form-group saturn-col saturn-flex-column"
                        labelText="Campaign UUID"
                        disabled={true}
                      />
                      <StackedDatePicker
                        className="edit-campaign__date saturn-form-group saturn-col saturn-flex-column"
                        labelText="Start Date"
                        htmlId="edit-campaign-start-date"
                        fieldName="startDate"
                        disabled={!this.areDatesEditable()}
                        onChange={this.onCampaignChange}
                        validate={(value: any) => validateStartDate(value, values)}
                      />
                      <StackedDatePicker
                        className="edit-campaign__date saturn-form-group saturn-col saturn-flex-column"
                        labelText="End Date"
                        htmlId="edit-campaign-end-date"
                        fieldName="endDate"
                        disabled={!this.areDatesEditable()}
                        onChange={this.onCampaignChange}
                        validate={(value: any) => validateEndDate(value, values)}
                      />
                    </Form>
                    {renderCampaignModule(childComponentRenderProps)}
                    {renderCampaignPublish(
                      this.props.campaign.status_id,
                      productFulfillment,
                      this.publishCampaign(values, client)
                    )}
                    <div className="edit-campaign__submit">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={!this.canSave(isSubmitting)}
                        onClick={() => submitForm()}
                      >
                        Save
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </Formik>
            </React.Fragment>
          )}
        </ApolloConsumer>
      </div>
    );
  }
}

const RoutableThomasCampaignEdit = withRouter(ThomasCampaignEdit);

export default RoutableThomasCampaignEdit;
